import { render, staticRenderFns } from "./ModalBusinessPreferences.vue?vue&type=template&id=64e2b40e&scoped=true&"
import script from "./ModalBusinessPreferences.vue?vue&type=script&lang=js&"
export * from "./ModalBusinessPreferences.vue?vue&type=script&lang=js&"
import style0 from "./ModalBusinessPreferences.vue?vue&type=style&index=0&id=64e2b40e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e2b40e",
  null
  
)

export default component.exports